import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { GRANULARITY_MODES } from '../hooks/usePersistedGranularity';
import type { GranularityMode } from '../hooks/usePersistedGranularity';

interface GranularityToggleProps {
  value: GranularityMode;
  onChange: (mode: GranularityMode) => void;
}

// Keyed by GranularityMode so the compiler enforces a label for every mode.
const LABELS: Record<GranularityMode, string> = {
  auto: 'Auto',
  hourly: 'Hourly',
  daily: 'Daily',
  weekly: '7-day',
  monthly: '30-day',
};

/**
 * Auto | Hourly | Daily | 7-day | 30-day granularity control. "Auto" keeps the
 * range-derived granularity; the others force the trend bucket size, overriding
 * the auto logic (see resolveGranularity). Modes come from GRANULARITY_MODES so
 * the button set stays in lockstep with the persisted/valid modes.
 */
export const GranularityToggle: React.FC<GranularityToggleProps> = ({ value, onChange }) => {
  const handleChange = (_: React.MouseEvent<HTMLElement>, next: GranularityMode | null) => {
    if (next === null) return;
    onChange(next);
  };

  return (
    <ToggleButtonGroup value={value} exclusive onChange={handleChange} size='small'>
      {GRANULARITY_MODES.map((mode) => (
        <ToggleButton key={mode} value={mode}>
          {LABELS[mode]}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};
